import View from './View';

export default View;

export { default as PredictiveModelReducer } from './PredictiveModelReducer';